export default __webpack_public_path__ + "static/media/investor3.5f9843fa.png";